export function csvError(f: string, e: unknown): Error {
  return new Error(`CSV parse error in file ${f}: ${JSON.stringify(e, null, 2)}`);
}

export function xlsxError(f: string, e: unknown): Error {
  return new Error(`XLSX parse error in file ${f}: ${JSON.stringify(e, null, 2)}`);
}